// Compact money for dashboard summaries: "$0", "$940", "$1.2k", "$45k".
export const formatCompactMoney = (n, symbol = '$') => {
  const v = Number(n) || 0;
  if (v >= 1000) return `${symbol}${(v / 1000).toFixed(1).replace(/\.0$/, '')}k`;
  return `${symbol}${v.toLocaleString()}`;
};

// Exact money, no cents: "$45,000". Returns null for falsy/zero so callers can omit it.
export const formatMoney = (n, symbol = '$') => {
  const v = Number(n);
  if (!v) return null;
  return `${symbol}${v.toLocaleString(undefined, { maximumFractionDigits: 0 })}`;
};
